export default __webpack_public_path__ + "static/media/books-plus-icon.5f289db8.svg";